module.exports = __webpack_public_path__ + "img/mobile-circles.ad5df590.png";